const appVersionEn = {
    appVersion: require('../../lang/en/app_version/AppVersion').default,
};

export default appVersionEn;
